import { ACTION } from './constants';

class AnalyticsHelper {
    async dispatchAdobeAnalytics(action: ACTION, location?: string, description?: string): Promise<void> {
        document.body.dispatchEvent(
            new CustomEvent('dataStateChange', {
                detail: {
                    action,
                    location,
                    description,
                },
            }),
        );
    }

    async setProductIdOnJLData(productId: string): Promise<void> {
        if (!window.jlData) {
            window.jlData = {
                page: {
                    productPages: {
                        productId: productId,
                    },
                },
            };
        } else {
            if (!window.jlData.page?.productPages?.productId) {
                window.jlData = Object.assign(window.jlData, {
                    page: {
                        productPages: {
                            productId: productId,
                        },
                    },
                }) as JLData;
            }
        }
    }
}

export * from './constants';

export const Analytics = new AnalyticsHelper();

export default Analytics;
